import { render, staticRenderFns } from "./BodyConfig.vue?vue&type=template&id=fd1fbb76&scoped=true"
import script from "./BodyConfig.vue?vue&type=script&lang=js"
export * from "./BodyConfig.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fd1fbb76",
  null
  
)

export default component.exports